import styled from 'styled-components';

export const Container = styled.div`
  width: 16px;
  height: 16px;

  left: 25px;

  border-radius: 50%;

  background-color: ${({ color }) => color};

  background-size: 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${({ icon }) => icon});
`;

export default {
  Container,
};
